import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InstallationPartyBccBsaPluginService } from './party-bcc-bsa.service';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'installation-party-bcc-bsa-edit',
    templateUrl: './party-bcc-bsa-edit.component.html',
    standalone: false
})
export class InstallationPartyBccBsaEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;

  private sub = new Subscription();

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationPartyBccBsaPluginService
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateBccBsa(this.inspectionId, this.pointId, this.pluginId, model).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public changeCheckboxValue(control) {
    control.setValue(!control.value);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = new UntypedFormGroup({
      label: new UntypedFormControl(this.plugin.config?.PartyBccBsa?.Label ?? ''),
      bobstBsf: new UntypedFormControl(this.plugin.config?.PartyBccBsa?.BobstBSF ?? false),
      bobstBcc: new UntypedFormControl(this.plugin.config?.PartyBccBsa?.BobstBCC ?? false),
      bobstAgent: new UntypedFormControl(this.plugin.config?.PartyBccBsa?.BobstAgent ?? false),
      customer: new UntypedFormControl(this.plugin.config?.PartyBccBsa?.Customer ?? false),
      thirdParty: new UntypedFormControl(this.plugin.config?.PartyBccBsa?.ThirdParty ?? false),
      na: new UntypedFormControl(this.plugin.config?.PartyBccBsa?.NA ?? false)
    });
  }
}
